import { render, staticRenderFns } from "./FreePackagesModal.vue?vue&type=template&id=2c3b100c&scoped=true"
import script from "./FreePackagesModal.vue?vue&type=script&lang=js"
export * from "./FreePackagesModal.vue?vue&type=script&lang=js"
import style0 from "./FreePackagesModal.vue?vue&type=style&index=0&id=2c3b100c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3b100c",
  null
  
)

export default component.exports